import { BaseModel } from 'paliari-js-utils'

const attrs = () => ({
  id: null,
  assunto_id: null,
  conteudo: '',
  contribuinte_id: null,
  enviado_em: null,
  excluida: false,
  arquivada_remetente: false,
  arquivada_destinatario: false,
  leitura_em: null,
  mensagem_id: null,
  para_fisco: false,
  permite_ler: false,
  permite_responder: false,
  prioridade: null,
  destinatario: (obj = {}) => ({ ...obj }),
  remetente: (obj = {}) => ({ ...obj }),
  resposta_em: null,
  status: '',
  tipo: null,
  titulo: '',
  anexos: [],
  updated_at: null,
  usuario_id: null,
  destinatario_id: null,
  remetente_id: null,
})

export default class Mensagem extends BaseModel {
  constructor(obj) {
    super(attrs(), obj)
  }
}
